import React from 'react';  
import axios from 'axios';  
import { Button, Space, Row, Col } from 'antd';  
import { useNotificationContext } from './NotificationContext';  
// const BaseUrlAddress = 'http://127.0.0.1:8000/'
const BaseUrlAddress = 'https://mrchap-co.ir/'
const API = axios.create({  
    baseURL: BaseUrlAddress,  
    withCredentials: true,  
});  

const Initilization = () => {  
    const notif = useNotificationContext(); // Get notif from context  

    API.interceptors.request.use(function (config) {  
        if (config.NeedsAuthorization) {  
            const token = localStorage.getItem('access_token');  
            if (token) {  
                config.headers.Authorization = `Bearer ${token}`;  
            }  
        }  
        return config;  
    }, function (error) {  
        return Promise.reject(error);  
    });  

    API.interceptors.response.use(  
      response => {  
        if (response.status == 200 && response.data != null && response.data.ResultCode != null && response.data.ResultCode != 200) {  
            openCustomErrorNotification(response.data.ResultMessage);  
        }  
        return response;
    },  
        error => {  
            if (error.response != null && error.response.status === 401) {  
                openNotification();  
            } else {  
                showErrorNotification();  
            }  
            return Promise.reject(error);  
        }  
    );  

    const openNotification = () => {  
        const key = "authentication-popup";  
        const btn = (  
            <Space>  
                <Row align={"center"}>
                    <Col align={"center"} span={24} md={12}>
                    <Button type="link" size="small" onClick={() => notif.destroy()}>  
                    بستن  
                </Button> 
                    </Col>
                    <Col align={"center"} span={24} md={12}>
                    <Button type="primary" onClick={() => accept()}>  
                    ورود  
                </Button>  
                    </Col>
                </Row>
                 
                
            </Space>  
        );  
        notif.open({  
            type: "info",  
            style: { width: "450px" },  
            className: "fYekan-bold",  
            placement: 'top',  
            duration: null,  
            message: 'ورود به سیستم',  
            description: 'برای ادامه باید وارد سیستم شوید، آیا میخواهید ادامه دهید؟',  
            btn,  
            key,  
        });  
    };  

    const showErrorNotification = () => {  
        const key = "notif-error-popup";  
        notif.open({  
            type: "error",  
            style: { width: "450px" },  
            className: "fYekan-bold",  
            placement: 'topRight',  
            message: 'خطا',  
            description: 'مشکلی در فراخوانی سرویس ها پیش آمده است.',  
            key,  
        });  
    };  

    const openCustomErrorNotification = (message) => {  
        const key = "notif-error-popup";  
        notif.open({  
            type: "error",  
            style: { width: "450px" },  
            className: "fYekan-bold",  
            placement: 'topRight',  
            message: 'خطا',  
            description: message,  
            key,  
        });  
    };  

    const accept = () => {  
        notif.destroy();  
        window.location.href = "/login-signup";  
    };  

    return <></>;  
};  

export { Initilization, API, BaseUrlAddress };  